import { render } from "./DeliveriesView.vue?vue&type=template&id=1943ca74&scoped=true&ts=true"
import script from "./DeliveriesView.vue?vue&type=script&lang=ts"
export * from "./DeliveriesView.vue?vue&type=script&lang=ts"

import "./DeliveriesView.vue?vue&type=style&index=0&id=1943ca74&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1943ca74"]])

export default __exports__